var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"registerChenggong"},[_c('img',{attrs:{"src":require("../../static/img/chenggong.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"Xiazaiapp",on:{"click":_vm.xiazai}},[_vm._v("去关注")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37af465e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/registerSuccess.vue
// module id = null
// module chunks = 